import React from 'react'
import PropTypes from 'prop-types'
import BookingResults from './BookingResults'
import BookingBar from './BookingBar'
import { BookingProvider } from './BookingContext'
import { MBooking } from '../types'

const BookingPage = ({ bookings, meta, user }) => {
  console.log(user)
  return (
    <BookingProvider>
      <BookingBar />
      <BookingResults bookings={bookings} meta={meta} user={user} />
    </BookingProvider>
  )
}

BookingPage.propTypes = {
  bookings: PropTypes.arrayOf(MBooking),
  user: PropTypes.object,
  meta: PropTypes.object
}

export default BookingPage
